/**
 * Call ajax to retrieve content of the country
 * via post_id of table fiea_mapsvg_regions_76
 */
function callAjaxSelectCountry() {
    let pageMap = document.querySelector('.page-template-page-map')
    if (pageMap != null) {
        let selectCountry = pageMap.querySelector('#select-country-member')

        if (isMobileDevice() == true) {
            let mapSVG = document.querySelector('.main_content');
            mapSVG.classList.add('hiddenElement');
        }

        selectCountry.addEventListener('change', (event) => {
            let post_id = event.target.value

            if (post_id != '') {
                $.ajax({
                    url: ajaxurl,
                    type: 'post',
                    data: {
                        action: 'ajax_pagination',
                        post_id: post_id
                    },
                    beforeSend: function(){
                        $('.page-loader').show();
                        $('.m-content-article-index').hide();
                    },
                    success: function( result ) {
                        $('.result_container').append(result);
                    },      
                    complete: function(data){          
                    $('html, body').animate({
                        scrollTop: $(".result_container").offset().top - 150
                    }, 1000)

                    $('.page-loader').hide();
            
                    }
                })
            }
        })
    }
}
callAjaxSelectCountry();